import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    collapse:
      'grid transition-[grid-template-rows,opacity,margin] duration-400 ease-in-out',
    collapseInner: 'overflow-hidden',
    block: 'flex flex-col gap-4 pt-2',
    header: 'order-first flex items-center justify-between gap-3 sm:pr-15',
    title: 'heading-l-regular min-w-0 sm:heading-xl',
    arrows: 'hidden shrink-0 items-center gap-5 sm:flex',
    carouselWrapper: 'touch-pan-y',
    carousel: [
      'flex flex-col gap-4',
      '[--slide-spacing:12px]',
      '[--slide-size:var(--mobile-slide-size)]',
      'sm:[--slide-size:var(--desktop-slide-size)]'
    ],
    viewport: '-mx-4 w-[calc(100%+32px)] px-4 sm:mx-0 sm:w-full sm:px-0',
    tile: [
      'w-full',
      '[&_.relative.z-20]:overflow-hidden',
      '[&_.bg-color-accent.absolute]:bottom-2',
      '[&_.bg-color-accent.absolute]:left-2',
      '[&_.bg-color-accent.absolute]:max-w-[calc(100%-16px)]'
    ],
    arrow:
      'heading-2xl hover:text-accent static top-auto right-auto left-auto flex size-6 translate-y-0 bg-transparent enabled:hover:bg-transparent',
    loader: 'flex min-h-75 items-center justify-center sm:min-h-80'
  },
  variants: {
    visible: {
      true: {
        collapse: 'mt-0 grid-rows-[1fr] opacity-100'
      },
      false: {
        collapse: 'pointer-events-none -mt-6 grid-rows-[0fr] opacity-0 sm:-mt-8'
      }
    }
  },
  defaultVariants: {
    visible: false
  }
});
